export default "__VITE_ASSET__DqCQkXMz__"